<template>
  <div class="className" />
</template>

<script>
import echarts from 'echarts' // echarts theme
import { debounce } from '@/utils/util'
require('echarts/theme/macarons')
export default {
  props: {
    className: {
      type: String,
      default: 'chart',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    chartData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    name: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      },
    },
  },
  mounted() {
    this.initChart()
    if (this.autoResize) {
      this.__resizeHandler = debounce(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 100)
      window.addEventListener('resize', this.__resizeHandler)
      setTimeout(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 600)
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    if (this.autoResize) {
      window.removeEventListener('resize', this.__resizeHandler)
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    setOptions({ mon, examinerCount, waterCount, orderCount } = {}) {
      this.chart.setOption({
        xAxis: {
          type: 'category',
          boundaryGap: false,
          splitLine: {
            show: false,
            lineStyle: {
              color: 'red', // 设置 X 轴网格线颜色为红色
              type: 'solid', // 设置网格线类型，可以是 'solid', 'dashed', 或 'dotted'
            },
          },
          // axisLabel: {
          //   formatter: function (value) {
          //     var res = value
          //     if (res.length > 6) {
          //       res = res.substring(0, 6) + '..'
          //     }
          //     return res
          //   },
          // },
          data: mon,
        },
        yAxis: {
          type: 'value',
          splitArea: {
            show: false, // 去除网格的背景色
          },
          axisLine: {
            show: false, // 不显示 y 轴线
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#263e5e', // 设置 Y 轴网格线颜色为蓝色
              // type: 'dashed', // 设置网格线类型，可以是 'solid', 'dashed', 或 'dotted'
            },
          },
        },
        grid: {
          left: '40px', // 去掉左边距
          right: '25px', // 去掉右边距
          top: '10px', // 根据需要设置顶部边距
          bottom: '20px', // 根据需要设置底部边距
        },
        tooltip: {
          trigger: 'axis',
        },
        series: [
          {
            data: examinerCount,
            type: 'line',
            areaStyle: {
              color: 'rgba(104, 187, 196,0.5)',
            },
            lineStyle: {
              color: '#68bbc4', // 这里修改为需要的颜色值
              width: 2,
              type: 'solid',
            },
            name: '验收员',
          },
          {
            data: waterCount,
            type: 'line',
            name: '水工',
            areaStyle: {
              color: 'rgba(23, 64, 111,0.5)',
            },
            lineStyle: {
              color: '#5087ec', // 这里修改为需要的颜色值
              width: 2,
              type: 'solid',
            },
          },
        ],
      })
    },
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)
    },
  },
}
</script>
<style less scoped>
.className {
  width: 100%;
  height: 20vh;
  /* height: 470px; */
}
</style>
